'use client';
import { useEffect, useState } from 'react';
import { motion } from 'motion/react';

/**
 * will display the message prop in a div as html
 * @param message
 * @returns {JSX.Element}
 * @constructor
 */
const TextDisplay = ({ message, loadedState }) => {
  const [markup, setMarkup] = useState({ __html: '' });
  const [isLoaded, setIsLoaded] = loadedState;
  const createMarkup = (message) => {
    return { __html: message.description };
  };

  useEffect(() => {
    const tmpMarkup = createMarkup(message);
    setMarkup(tmpMarkup);
    setIsLoaded(true);
  }, [message]);

  return (
    isLoaded && (
      <motion.div
        initial={{ opacity: 0, height: 0 }}
        animate={{
          opacity: 1,
          height: 'auto',
          transition: {
            duration: 0.5,
            ease: 'easeIn',
          },
        }}
        exit={{ opacity: 0, height: 0, transition: { duration: 1 } }}
        className="text-display"
        dangerouslySetInnerHTML={markup}
      ></motion.div>
    )
  );
};

export default TextDisplay;
